import React, { useState, useEffect } from 'react';
import './CrudPage.css';
import './LicenseHub.css';
import Dashboard from './Dashboard';
import LicenseLimitsPage from './LicenseLimitsPage';
import {
  LicenseHubTab,
  readStoredLicenseTab,
  storeLicenseTab,
} from '../utils/pageStorage';

const TABS: { id: LicenseHubTab; label: string }[] = [
  { id: 'overview', label: 'License Overview' },
  { id: 'limits', label: 'Limits' },
];

const LicenseHub: React.FC = () => {
  const [activeTab, setActiveTab] = useState<LicenseHubTab>(() => readStoredLicenseTab());

  useEffect(() => {
    storeLicenseTab(activeTab);
  }, [activeTab]);

  return (
    <div className="crud-page license-hub">
      <div className="license-hub-tabs">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={`license-hub-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="license-hub-content">
        {activeTab === 'overview' && <Dashboard />}
        {activeTab === 'limits' && <LicenseLimitsPage />}
      </div>
    </div>
  );
};

export default LicenseHub;
